import {enum_costCurrency_n, enum_langCodes, enum_runIn_es, enum_storeIn} from "../functions/src/shareCode/Share_S_Enum";
import {FB_FbAuth, FB_OsInfo, FB_QuestEvent, FB_UserGeoLocation} from "../functions/src/shareCode/Share_S_Classes";
import {enum_moveToOptions} from "../functions/src/shareCode/Share_S_Enum";
import {crypto_decrypt_fs, crypto_encrypt_fs} from "../functions/src/shareCode/Share_S_Crypto";
import {obj_forEach_f} from "../functions/src/shareCode/Share_S_Obj";
import {helper_getClassAsObj} from "./scripts/S_Helper";
import {gv_strings} from "./scripts/S_GlobalVar";

const store_currentDbVersion_n = 2
const localData_byStoreName = {}

export const store_var = {

    // firebase
    FB_activeRefs : {
        name                    : 'FB_activeRefs',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return {} }
    },
    fb_auth : {
        name                    : 'fb_auth',
        storeIn_e               : enum_storeIn.localStorage,
        getAsClass              : (val) => new FB_FbAuth(val)
    },
    serverCacheTree : {
        name                    : 'serverCacheTree',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {} }
    },
    failedHttpsCalls : {
        name                    : 'failedHttpsCalls',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {}}
    },
    failedWebSocketUpdates : {
        name                    : 'failedWebSocketUpdates',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {}}
    },

    // system
    system_clock_dateTime : {
        name                    : 'system_clock_dateTime',
        storeIn_e               : enum_storeIn.sessionStorage,
    },
    system_windowSizeType_e : {
        name                    : 'system_windowSizeType_e',
        storeIn_e               : enum_storeIn.sessionStorage,
    },
    system_screenWidth : {
        name                    : 'system_screenWidth',
        storeIn_e               : enum_storeIn.none,
    },
    system_langCode : {
        name                    :'system_langCode',
        storeIn_e               : enum_storeIn.localStorage,
        defaultValue_f          : () => {
            let browserLangCode_s = window.navigator.language //en, en-US ...

            if(browserLangCode_s.includes(gv_strings.hebrewCode)){
                return enum_langCodes.hebrew
            }

            for(let label_s in enum_langCodes){
                if(browserLangCode_s.includes(enum_langCodes[label_s]) ){
                    return enum_langCodes[label_s]
                }
            }
            return enum_langCodes.english
        }
    },
    system_currency : {
        name                    :'currency',
        storeIn_e               : enum_storeIn.localStorage,
        defaultValue_f          : () => {
            return  enum_costCurrency_n.SHEKEL
        }

    },
    system_currentUserLocation : {
        name                    : 'system_currentUserLocation',
        storeIn_e               : enum_storeIn.sessionStorage,
        getAsClass              : (val) => {
            console.log("test")
            return new FB_UserGeoLocation(val)
        },
    },
    system_compassHeading_c : {
        name                    :'system_compassHeading_c',
        storeIn_e               : enum_storeIn.none,
    },
    system_compassHeading_offSet_byDiffN: {
        name                    : 'system_compassHeading_offSet_byDiffN',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => { return  {} }
    },
    system_inputFocus_b : {
        name                    : 'system_inputFocus_b',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => { return false}
    },
    system_osInfo_c : {
        name                    :'system_osInfo_c',
        storeIn_e               : enum_storeIn.none,
        getAsClass              : (val) => {return new FB_OsInfo(val)}
    },
    system_displayKeyboard_b : {
        name                    :'system_displayKeyboard_b',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => { return false }
    },
    system_shortScreen_b : {
        name                    :'system_shortScreen_b',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => { return false }
    },
    system_requestCameraPermission_b : {
        name                    :'system_cameraPermission_b',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => { return false }
    },
    networkActive : {
        name                    : 'networkActive',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => { return false }
    },
    system_serviceWorkerCacheLoader_b : {
        name                    : 'system_serviceWorkerCacheLoader_b',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : false
    },
    system_continueWithCurrentBrowser_b :{
        name                    : 'system_continueWithCurrentBrowser_b',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {false}
    },
    system_runIn_e :{
        name                    : 'system_runIn_e',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return enum_runIn_es.other}
    },
    system_newSocketDatabaseId_be_s :{
        name                    : 'system_newSocketDatabaseId_be_s',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {}}
    },
    system_socketDatabaseCloseStatus_be_s :{
        name                    : 'system_socketDatabaseCloseStatus_be_s',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return {}}
    },
    system_scrollToBottom_b :{
        name                    : 'system_scrollToBottom_b',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return false}
    },
    system_serverTimeOffset_n :{
        name                    : 'system_serverTimeOffset_n',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return 0}
    },
    system_approveCookiesPolicyVersion_s :{
        name                    : 'system_approveCookiesPolicyVersion_s',
        storeIn_e               : enum_storeIn.localStorage,
        defaultValue_f          : () => {return '000'}
    },

    // player
    player_urlTicketId_uid : {
        name                    :'player_urlTicketId_uid',
        storeIn_e               : enum_storeIn.localStorage,
    },
    player_agentId_uid : {
        name                    :'player_agentId_uid',
        storeIn_e               : enum_storeIn.sessionStorage,
    },
    player_storePath_s : {
        name                    :'player_storeLocation_s',
        storeIn_e               : enum_storeIn.none,
    },

    // creator
    creator_events_item_observableTeamsIds_byQuestId_as:{
        name                    :'creator_events_item_observableTeamsIds_byQuestId_as',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {}}
    },
    creator_drive_displayFilesNum_byPath_byFileLabel_n: {
        name: 'creator_drive_displayFilesNum_byPath_byFileLabel_n',
        storeIn_e: enum_storeIn.sessionStorage,
        defaultValue_f: () => {
            return {}
        }
    },
    creator_drive_foldersPath_ac: {
        name: 'creator_drive_foldersPath_ac',
        storeIn_e: enum_storeIn.none,
        defaultValue_f: () => {
            return []
        }
    },

    // ongoing
    ongoing_questEvent : {
        name                    :'ongoing_questEvent',
        storeIn_e               : enum_storeIn.localStorage,
        getAsClass              : (val) => {return new FB_QuestEvent(val)},
    },
    ongoing_ticketShortKey_s : {
        name                    :'ongoing_ticketShortKey',
        storeIn_e               : enum_storeIn.localStorage,
    },
    ongoing_eventCurrentStatus : {
        name                    : 'ongoing_eventCurrentStatus',
        storeIn_e               : enum_storeIn.localStorage,
    },
    ongoing_currentTeamId_uid : {
        name                    :'ongoing_currentTeamId_uid',
        storeIn_e               : enum_storeIn.localStorage,
    },
    ongoing_cardsRiddles_lastIndex_n : {
        name                    : 'ongoing_cardsRiddles_lastIndex_n',
        storeIn_e               : enum_storeIn.localStorage,
    },
    ongoing_skipsNum_n : {
        name                    : 'ongoing_skipsNum_n',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return -1}

    },
    ongoing_cluesNum_n : {
        name                    : 'ongoing_cluesNum_n',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return -1}
    },
    ongoing_currentScore_n : {
        name                    : 'ongoing_currentScore_n',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return null}
    },
    ongoing_millSecToEndQuest_n : {
        name                    : 'ongoing_millSecToEndQuest_n',
        storeIn_e               : enum_storeIn.localStorage,
        defaultValue_f          : () => {return 0}
    },
    ongoing_qrScannerCb_f : {
        name                    :'ongoing_qrScannerCb_f',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return null}
    },
    ongoing_fullScreenImage_s : {
        name                    :'ongoing_fullScreenImage_s',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {return null}
    },
    ongoing_chat_msgShowTranslate_byMsgTime_b : {
        name                    :'ongoing_chat_msgShowTranslate_byMsgTime_b',
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f          : () => {return {}}
    },

    // route
    lastRoute_ongoing_openMap_map : {
        name                    : 'lastRoute_ongoing_openMap_map',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {
            return {path : enum_moveToOptions.ongoing_quest_openMap_map}
        }
    },
    lastRoute_ongoing_polygonMap : {
        name                    : 'lastRoute_ongoing_polygonMap',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {
            return {path : enum_moveToOptions.ongoing_quest_openMapPolygons_missions}
        }
    },
    lastRoute_ongoing_missions : {
        name                    : 'lastRoute_ongoing_missions',
        storeIn_e               : enum_storeIn.none,
        defaultValue_f          : () => {
            return {path : enum_moveToOptions.ongoing_Missions_List}
        }
    },

    // navBar
    navBar_tabs_ac : {
        name                    : "navBar_tabs_ac",
        storeIn_e               : enum_storeIn.none,
    },
    navBar_menu_ac : {
        name                    : "navBar_menu_ac",
        storeIn_e               : enum_storeIn.none,
    },
    navBar_showedBeacon_byPath_b : {
        name                    : "navBar_showedBeacon_byPath_b",
        storeIn_e               : enum_storeIn.sessionStorage,
        defaultValue_f() {
            return {}
        }
    },

}

// ============== public ==================

// store_setStateValue
export const store_clean = () => {
    localStorage.clear();
    sessionStorage.clear();
}

// store_setStateValue
export const store_setStateValue = (stateObj_o, val) => {

    // init store
    if(localData_byStoreName[stateObj_o.name] == null){
        localData_byStoreName[stateObj_o.name] = {val : null}
    }

    // local storage
    let encrypted;
    switch(stateObj_o.storeIn_e){

        case enum_storeIn.sessionStorage:
            // compressed = lzString.compressToUTF16(JSON.stringify(helper_getClassAsObj(val)))
            encrypted = crypto_encrypt_fs(helper_getClassAsObj(val))
            try{
                sessionStorage.setItem(stateObj_o.name, JSON.stringify({val_s: encrypted, version_n: store_currentDbVersion_n}))
            }catch{
                console.log("sessionStorage error", e)
            }
            break;

        case enum_storeIn.localStorage:
            // compressed = lzString.compressToUTF16(JSON.stringify(helper_getClassAsObj(val)))
            encrypted = crypto_encrypt_fs(helper_getClassAsObj(val))

            try{
                localStorage.setItem(stateObj_o.name, JSON.stringify({val_s: encrypted, version_n: store_currentDbVersion_n}))
            }catch(e){
                console.log("localstorage error", e)
            }
            break;

        case enum_storeIn.none:
            break;
    }

    localData_byStoreName[stateObj_o.name].val = val
    localData_byStoreName[stateObj_o.name].defaultValue = false

    if(localData_byStoreName[stateObj_o.name].cb_byWebView_f){
        obj_forEach_f(localData_byStoreName[stateObj_o.name].cb_byWebView_f, (cb_f)=>{
            cb_f(val)
        })
    }


}

// store_getStateValue_vo
export const store_getStateValue_vo = (stateObj_o) => {


    if(localData_byStoreName[stateObj_o.name] == null){
        localData_byStoreName[stateObj_o.name] = {val : null}
    }

    if(localData_byStoreName[stateObj_o.name].val != null) {
        return localData_byStoreName[stateObj_o.name]
    }

    if(stateObj_o.storeIn_e === enum_storeIn.none){
        localData_byStoreName[stateObj_o.name].val = stateObj_o.defaultValue_f ? stateObj_o.defaultValue_f() : null
    }else{
        try {
            let value;
            let defaultValue = false

            if (stateObj_o.storeIn_e === enum_storeIn.sessionStorage) {
                value = sessionStorage.getItem(stateObj_o.name)
            } else if (stateObj_o.storeIn_e === enum_storeIn.localStorage) {
                value = localStorage.getItem(stateObj_o.name)
            }

            if(value != null ){
                try{
                    value = JSON.parse(value)
                }catch(err){
                    // console.log(err)
                }
            }

            if(value && value.version_n === store_currentDbVersion_n){
                value = crypto_decrypt_fs(value.val_s)
            }else{
                value = null
            }

            if (value === '' || value == null) {
                value = stateObj_o.defaultValue_f ? stateObj_o.defaultValue_f() : null
                defaultValue = true
            } else if (stateObj_o.getAsClass != null) {
                value = stateObj_o.getAsClass(value)
            }


            localData_byStoreName[stateObj_o.name].val = value
            localData_byStoreName[stateObj_o.name].defaultValue = defaultValue

        }
        catch(err){
            console.log(err)
        }
    }


    return localData_byStoreName[stateObj_o.name]

}

// store_listener_set_f
export const store_listener_set_f = (stateObj_o, webView_s, cb_f) => {

    if(localData_byStoreName[stateObj_o.name] == null){
        localData_byStoreName[stateObj_o.name] = {val : null}
    }

    // add cb to storeVar
    if(webView_s && cb_f){
        if(localData_byStoreName[stateObj_o.name].cb_byWebView_f == null ){
            localData_byStoreName[stateObj_o.name].cb_byWebView_f = {}
        }
        localData_byStoreName[stateObj_o.name].cb_byWebView_f[webView_s] = cb_f
    }

    cb_f(store_getStateValue_vo(stateObj_o).val)
}

// store_listener_remove_f
export const store_listener_remove_f = (stateObj_o, webView_s) => {

    if(localData_byStoreName[stateObj_o.name] == null){
        localData_byStoreName[stateObj_o.name] = {val : null}
    }

    // add cb to storeVar
    if(webView_s){
        if(localData_byStoreName[stateObj_o.name].cb_byWebView_f == null ){
            localData_byStoreName[stateObj_o.name].cb_byWebView_f = {}
        }

        delete localData_byStoreName[stateObj_o.name].cb_byWebView_f[webView_s]
    }
}
